import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// ===== Admin Imports =====
import AdminLogin from "./admin/AdminLogin";
import AdminPanel from "./admin/AdminPanel";
import AddCourse from "./admin/AddCourse";
import AdminCourse from "./admin/adminCourse";
import AdminCertificate from "./admin/adminCertificate";
import EditCourse from "./admin/EditCourse";
import AddCertificate from "./admin/addCertificate";
import EditCertificate from "./admin/editCertificate";
import AdminPartner from "./admin/AdminPartner";
import AdminEnroll from "./admin/adminEnroll";
import AdminEventPoster from "./admin/AdminEventPoster";
import UploadEvent from "./admin/uploadEvent";
import AdminForm from "./admin/AdminForm";
import ContactUser from "./admin/contactUser";
// ===== User Imports =====
import Navbar from "./components/Navbar";
import Footer from "./components/footer";
import Gallery from "./components/Gallery";
import Home from "./components/Home";
import CertificateEnrollTemplate from "./components/CertificateEnrollTemplate";
import Contact from "./components/Contact";
import About from "./components/About";
import Certificate from "./components/Certificate";
import CourseList from "./components/CourseList";
import CourseEnrollTemplate from "./components/courseEnrollTemplate";
import WhatsAppWidget from "./components/WhatsAppWidget";
import ScrollToTop from "./components/ScrollToTop";


import "./App.css";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
    <ScrollToTop />
      {isAdminRoute ? (
        // ===== Admin Routes =====
        <Routes>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/panel" element={<AdminPanel />} />
          <Route path="/admin/courses" element={<AdminCourse />} />
          <Route path="/admin/addcourse" element={<AddCourse />} />
          <Route path="/admin/editCourse/:id" element={<EditCourse />} />
          <Route path="/admin/certificates" element={<AdminCertificate />} />
          <Route path="/admin/add-certificate" element={<AddCertificate />} />
          <Route path="/admin/edit/:id" element={<EditCertificate />} />
          <Route path="/admin/partners" element={<AdminPartner />} />
           <Route path="/admin/enroll" element={<AdminEnroll />} />
           <Route path="/admin/event-poster" element={< AdminEventPoster/>} />
           <Route path="/admin/userEvent" element={< UploadEvent />} />
           <Route path="/admin/adminform" element={< AdminForm/>} />
           <Route path="/admin/contactUser" element={< ContactUser/>} />
          <Route path="*" element={<h2>404 Not Found (Admin)</h2>} />
        </Routes>
      ) : (
        // ===== User Routes =====
        <>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
             <Route path="/about" element={<About />} />
             <Route path="/gallery" element={<Gallery />} />
             <Route path="/course" element={<CourseList />} />
            <Route path="/course-enroll-template/:id" element={<CourseEnrollTemplate />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/certificate-enroll-template/:id" element={<CertificateEnrollTemplate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<h2>404 Not Found</h2>} />
          </Routes>
           <WhatsAppWidget />
          <Footer />
        </>
      )}
      {/* <Footer /> */}
    </>
  );
}

export default App;

